export default __webpack_public_path__ + "static/media/font.a1b3edf7.svg";